var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"graphViz"}},[_c('v-main',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-row',[_c('v-col',[_c('router-view')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }